import * as React from 'react';
import { InvoiceCategory } from 'api/invoice';
import { colors, State, StateFlow, StateLine } from 'lqx-react';
import { InvoiceModel } from '../../../../api/invoice';

export type CategoryTab = InvoiceCategory | 'all' | 'separator' | 'remittance-advices' | 'details' | 'statement';

export const categories: CategoryTab[] = [ 'all', 'disputed', 'pending', 'paymentinprogress', 'complete' ];

export function invoiceStatusColor( status ) {
    switch ( status ) {
        case 'ApprovalNeeded':
        case 'AwaitingRemittance':
            return colors.yellow;

        case 'DisputedWithCustomer':
        case 'DisputedWithSupplier':
            return colors.red;

        case 'PaymentInTransit':
        case 'Reconciled':
        case 'PaymentComplete':
            return colors.green;

        default:
            return colors.grey;
    }
}

export const InvoiceStateFlow = ({ invoice }) =>
    <StateFlow>
        <State
            checked={ invoiceChecked( invoice ) }
            color={ invoiceColor( invoice ) }
        >
            Invoice
        </State>

        <StateLine />

        <State
            checked={ paymentChecked( invoice ) }
            color={ paymentColor( invoice ) }
        >
            Payment
        </State>

        <StateLine />

        <State
            checked={ reconChecked( invoice ) }
            color={ reconColor( invoice ) }
        >
            Recon
        </State>
    </StateFlow>;

function invoiceColor( invoice: InvoiceModel ) {
    switch ( invoice.category ) {
        case 'disputed' :
            switch ( invoice.invoiceStatus ) {
                case 'AwaitingRemittance' :
                case 'ApprovalNeeded' :
                    return 'red';

                case 'PaymentInTransit':
                case 'Reconciled':
                    return 'green';

                default:
                    return 'gray';
            }

        case 'pending' :
            return 'blue';

        case 'paymentinprogress' :
        case 'complete' :
            return 'green';

        default:
            return null;
    }
}

function paymentColor( invoice: InvoiceModel ) {
    switch ( invoice.category ) {
        case 'disputed' :
            switch ( invoice.invoiceStatus ) {
                case 'AwaitingRemittance':
                case 'ApprovalNeeded':
                    return 'grey';

                case 'PaymentInTransit':
                    return 'red';

                case 'Reconciled':
                    return 'green';

                default:
                    return null;
            }
            
        case 'pending' :
            return 'grey';

        case 'paymentinprogress' :
        case 'complete' :
            return 'green';

        default:
            return null;
    }
}

function reconColor( invoice: InvoiceModel ) {
    switch ( invoice.category ) {
        case 'disputed' :
            switch ( invoice.invoiceStatus ) {
                case 'AwaitingRemittance':
                case 'ApprovalNeeded':
                case 'PaymentInTransit':
                    return 'grey';

                case 'Reconciled':
                  return 'red';

                default:
                    return null;
            }

        case 'pending' :
            return 'grey';

        case 'paymentinprogress' :
          switch ( invoice.invoiceStatus ) {
              case 'PaymentInTransit':
                return 'grey';
              case 'Reconciled':
                return 'blue';
              default:
                return null;
          }

        case 'complete' :
            return 'green';

        default:
            return null;
    }
}

export const PromiseToPayDateSelectedInvoiceIdContext = React.createContext(null);

const reconChecked = ( invoice: InvoiceModel ) =>  invoice.category === 'complete';

const paymentChecked = ( invoice: InvoiceModel ) => invoice.category === 'paymentinprogress'
                                                     || invoice.category === 'complete'
                                                     || reconChecked( invoice );

const invoiceChecked = ( invoice: InvoiceModel ) => invoice.category === 'paymentinprogress'
                                                     || invoice.category === 'complete'
                                                     || paymentChecked( invoice );
